import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {useAppSelector} from "../hooks";
import {selectMembers} from "../redux/members";
import useFrontLogic from "../logic/useFrontLogic";

export const useSwitchUserCommand = (): ICommand => {
  const messages = useMessageLogic()
  const members = useAppSelector(selectMembers)
  const { updateFronts } = useFrontLogic()

  return {
    secure: true,

    help(): string {
      return '- su [USERNAME?,USERNAME2,...]\t\t:: sets the fronting member(s) of the system';
    },

    async process(msg: string): Promise<void> {
      const memberName = msg.substring('su '.length).trim()
      if (memberName !== '') {
        const memberNames = memberName.split(',').map((m) => m.trim())
        const fronts = members.filter((m) => memberNames.includes(m.name))
        if (fronts.length) {
          await updateFronts(fronts)
          messages.addSuccessMessage(`set front` + (fronts.length > 1 ? '(s)' : '') + ` to '` + memberNames.join(', ') + `'`)
        } else {
          messages.addErrorMessage(`could not find member '${memberName}'`)
        }
      } else {
        messages.addErrorMessage('no member name provided')
      }
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim().startsWith('su ')
    }
  };
}